import React from "react";
import { useTranslation } from "react-i18next";
import InfoSection from "@quest_editor/components/InfoSection";
import DeliveryDivisionField from "./DeliveryDivisionField";
import EligibleSearchField from "./EligibleSearchField";
import DeliveryNumberField from "./DeliveryNumberField";

const DeliverySection = ({
  divisions,
  setDivisions,
  eligibleCount,
  onSearchEligible,
  deliveryNumber,
  setDeliveryNumber,
  onCalcFromTargetClearCount,
}: {
  divisions: number[];
  setDivisions: React.Dispatch<React.SetStateAction<number[]>>;
  eligibleCount: number;
  onSearchEligible: () => void;
  deliveryNumber: number;
  setDeliveryNumber: React.Dispatch<React.SetStateAction<number>>;
  onCalcFromTargetClearCount: () => void;
}) => {
  const { t } = useTranslation("questEditor");

  return (
    <InfoSection
      title={t("quest_edit_target.section.number_of_deliveries")}
      rows={[
        {
          label: t("quest_edit_target.field.number_of_deliveries.division"),
          children: (
            <DeliveryDivisionField
              divisions={divisions}
              setDivisions={setDivisions}
            />
          ),
        },
        {
          label: t(
            "quest_edit_target.field.number_of_deliveries.search_eligible_people",
          ),
          children: (
            <EligibleSearchField
              eligibleCount={eligibleCount}
              onSearch={onSearchEligible}
            />
          ),
        },
        {
          label: t(
            "quest_edit_target.field.number_of_deliveries.number_of_deliveries",
          ),
          children: (
            <DeliveryNumberField
              deliveryNumber={deliveryNumber}
              setDeliveryNumber={setDeliveryNumber}
              onCalcFromTargetClearCount={onCalcFromTargetClearCount}
            />
          ),
        },
      ]}
    />
  );
};

export default DeliverySection;
